define('views/modules/member/member/lists/member-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // collections
    'collections/member/profiles',
    // models
    'models/member/profile',
    //services
    'services/user',
    // views
    'views/modules/member/member/lists/member-list-item',
    'views/parts/list/fetch-list',
    // templates
    'text!templates/modules/member/member/lists/member-list.html',

], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // collections
    CProfiles,
    // models
    MProfile,
    //services
    User,
    // views
    VMemberItem,
    VFetchList,
    // templates
    TMemberList
) {

    var VMemberList = Backbone.Epoxy.View.extend({
        template: TMemberList,
        regions: {
            root: ".member-list-root",
            list: ".member-list",
        },
        computeds: {
            // bind the collection's total count indicated by the server.
            stateTotal: {
                deps: ["$collection", ],
                get: function(collection) {
                    return collection.state.total;
                },
            }
        },

        initialize: function(opt) {
            this.unitsCheckMemberDone = { 'active_UnitsCheckDone': false, 'pending_UnitsCheckDone': false, 'expired_UnitsCheckDone': false }; //Client list check for required Units  length/distance/weight
            this.atLeastOneClientUpdated = false;
            this.bNeedUpdate = false;
            this.attrs = null;

            opt = opt || {};
            opt = this.options = _.extend({
                title: "Clients",
                icon: "sl-icon-people"
            }, opt);

            _.extend(this, {
                allStatusCombinedMembers: opt.allStatusCombinedMembers
            });

            var collection = this.collection = new CProfiles(null, {
                    pageSize: opt.pageSize,
                    status: opt.status,
                }),
                view = this.view = {
                    list: new VFetchList({
                        collection: this.collection,
                        item: VMemberItem,
                        bottom: true,
                        itemOptions: {
                            supervisors: this.options.supervisors,
                        },
                        button: {
                            label: 'Show more'
                        }
                    }),
                };

            this.listenTo(collection, {
                    'sync': this.onCollectionSync,
                    'update': this.onCollectionUpdate,
                })
                .listenTo(opt.supervisors, 'sync', this.render);
        },

        render: function() {
            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones()
                .applyBindings();

            var view = this.view,
                zone = this.zone;
            this.assign(view.list, zone.$list);

            this.collection.resetQuery();

            return this;
        },

        getCollection: function() {
            return this.collection;
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                supervisors: this.supervisors
            });
        },

        resetList: function(group) {
            this.unitsCheckMemberDone = { 'active_UnitsCheckDone': false, 'pending_UnitsCheckDone': false, 'expired_UnitsCheckDone': false };
            this.collection.getFirstPage({
                context: this,
                reset: true,
                group: group,
                groups: this.options.groups,
                supervisors: this.options.supervisors
            });
        },

        setCollectionQuery: function(value) {
            this.collection.setQuery(value);
        },

        addMembersToMainList: function() {
            this.allStatusCombinedMembers.add(this.collection.models);
        },

        ////////////
        // events //
        ////////////
        onCollectionSync: function() {
            if (!this.unitsCheckMemberDone[this.options.status + '_UnitsCheckDone'])
              this.checkIfRequiredFieldsExistsInClientsProfiles();

            this.addMembersToMainList();
            this.$el.toggle(Boolean(this.collection.state.total));
        },

        onCollectionUpdate: function() {
            this.collection.state.total = this.collection.length;
            this.$el.toggle(Boolean(this.collection.state.total));
        },

        setUnitEmptyField: function(userIndex, units) {
          if (_.isEmpty(units.distance)) {
             this.bNeedUpdate = true;
             this.collection.models[userIndex].set("distanceUnit", User.get("units").distance, { silent: true });
          }
          if (_.isEmpty(units.length)) {
            this.bNeedUpdate = true;
            this.collection.models[userIndex].set("lengthUnit", User.get("units").length, { silent: true });
          }
          if (_.isEmpty(units.weight)) {
            this.bNeedUpdate = true;
            this.collection.models[userIndex].set("weightUnit", User.get("units").weight, { silent: true });
          }
          this.attrs = this.collection.models[userIndex].changedAttributes();
        },

        checkIfRequiredFieldsExistsInClientsProfiles: function(options) {
          for (var i = 0; i < this.collection.length; i++) {
              var units = this.collection.models[i].get("units");

              this.setUnitEmptyField(i, units);

              if (_.isEmpty(this.collection.models[i].get("timezone"))) {
                this.bNeedUpdate = true;
                this.collection.models[i].set("timezone", User.get("timezone"), { silent: true });
                this.attrs.timezone = User.get("timezone");
              }
              if (_.isEmpty(this.collection.models[i].get("country"))) {
                this.bNeedUpdate = true;
                this.collection.models[i].set("country", User.get("country"), { silent: true });
                this.attrs.country = User.get("country");
              }
              if (_.isEmpty(this.collection.models[i].get("province"))) {
                this.bNeedUpdate = true;
                this.collection.models[i].set("province", User.get("province"), { silent: true });
                this.attrs.province = User.get("province");
              }
              if (_.isEmpty(this.collection.models[i].get("language"))) {
                this.bNeedUpdate = true;
                this.collection.models[i].set("language", User.get("language"), { silent: true });
                this.attrs.language = User.get("language");
              }
              if (this.bNeedUpdate === true) {
                 this.collection.models[i].save(this.attrs, _.extend({
                         patch: !this.collection.models[i].isNew(),
                         context: this,
                         validate: false,
                     }, options));
                this.atLeastOneClientUpdated = true;
              }
            }
          this.unitsCheckMemberDone[this.options.status + '_UnitsCheckDone'] = true;
          if (this.atLeastOneClientUpdated && this.unitsCheckMemberDone.pending_UnitsCheckDone && this.unitsCheckMemberDone.expired_UnitsCheckDone && this.unitsCheckMemberDone.active_UnitsCheckDone) {
              Backbone.history.loadUrl(Backbone.history.fragment);
          }
        },
    });

    return VMemberList;

});

